import React, { useEffect, useRef, useState } from 'react';
import { animate, useInView, useReducedMotion } from 'framer-motion';

const fmt = new Intl.NumberFormat('en-US');

/** Counts up from 0 to `value` once scrolled into view. `format` adds thousands separators. */
export default function AnimatedCounter({ value = 0, duration = 1.4, format = true, prefix = '', suffix = '', className = '' }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.5 });
  const reduce = useReducedMotion();
  const target = Number(value) || 0;
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return undefined;
    if (reduce) {
      setDisplay(target);
      return undefined;
    }
    const controls = animate(0, target, { duration, ease: [0.16, 1, 0.3, 1], onUpdate: (v) => setDisplay(v) });
    return () => controls.stop();
  }, [inView, target, duration, reduce]);

  const show = (n) => (format ? fmt.format(Math.round(n)) : String(Math.round(n)));
  return (
    <span ref={ref} className={`tabular-nums ${className}`}>
      <span className="sr-only">
        {prefix}
        {show(target)}
        {suffix}
      </span>
      <span aria-hidden="true">
        {prefix}
        {show(display)}
        {suffix}
      </span>
    </span>
  );
}
